import { StyledTooltipIcon } from '../select/styled';
import { theme } from '../theme';
import { Tooltip } from '../tooltip';
import { BodyText, Label } from '../typography';
import { StyledInfoItem, StyledInfoName, StyledInfoRowWrapper } from './styled';

export interface InfoRowProps {
  label?: string;
  value?: string;
  labelTooltip?: React.ReactNode;
}

export const InfoRow: React.FC<InfoRowProps> = ({
  label,
  value,
  labelTooltip,
}) => (
  <StyledInfoRowWrapper>
    <StyledInfoName>
      {labelTooltip && (
        <Tooltip
          placement="topRight"
          title={labelTooltip}
          color={theme.colors.primaryK10}>
          <StyledTooltipIcon />
        </Tooltip>
      )}
      <Label>{label}</Label>
    </StyledInfoName>
    <StyledInfoItem>
      <BodyText>{value || '-'}</BodyText>
    </StyledInfoItem>
  </StyledInfoRowWrapper>
);
